import React from 'react';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { validationClasses } from '@/utils/errors';
import { camelConverter } from '../helper';

const FormPhone = ({
  field,
  text,
  onChange,
  disabled,
  autoFocus,
  error,
}) => (
  <PhoneInput
    autoFocus={autoFocus}
    id={camelConverter(field.name, '_')}
    containerClass="aridhia-phone-input"
    preferredCountries={field.preferredCountries}
    country={field.country}
    value={text}
    onChange={(value) => onChange(value)}
    disabled={disabled}
    className={validationClasses(error, 'aridhia-form-phone')}
  />
);

export default FormPhone;
